
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"action.label":"CSV-Datei","dialog.title":"CSV-Datei wird erstellt"},"en":{"action.label":"CSV file","dialog.title":"Generating data"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();